import { Link } from 'react-router-dom';

const comparisonData = [
  {
    id: 'mitsui',
    name: '三井住友カード（NL）',
    issueTime: '最短10秒',
    receiveMethod: 'アプリ即時',
    storePickup: '×',
    annualFee: '永年無料',
    returnRate: '0.5%～7%',
    detailUrl: '/mitsui'
  },
  {
    id: 'rakuten',
    name: '大手ECモール系カード',
    issueTime: '最短即日',
    receiveMethod: '郵送',
    storePickup: '×',
    annualFee: '永年無料',
    returnRate: '1.0%～3.0%',
    detailUrl: '/rakuten'
  },
  {
    id: 'recruit',
    name: 'リクルートカード',
    issueTime: '最短即日',
    receiveMethod: '郵送',
    storePickup: '×',
    annualFee: '永年無料',
    returnRate: '1.2%',
    detailUrl: '/recruit'
  },
  {
    id: 'suruga',
    name: '地方銀行系スピード発行カード（一般カード）',
    issueTime: '最短5分',
    receiveMethod: 'アプリ即時（スピード発番）',
    storePickup: '×',
    annualFee: '初年度無料',
    returnRate: '0.5%（優待店2〜20倍）',
    detailUrl: '/suruga'
  },
  {
    id: 'ja',
    name: 'JAカード',
    issueTime: '最短5営業日',
    receiveMethod: '郵送',
    storePickup: '×',
    annualFee: '初年度無料',
    returnRate: '0.5%～1.0%',
    detailUrl: '/ja'
  }
];

export default function ComparisonTable() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4 text-gray-900">
          即日発行カード比較一覧表
        </h2>
        <p className="text-center text-gray-600 mb-12">
          発行スピード・受取方法を一目で比較できます
        </p>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-teal-500 to-teal-600 text-white">
                  <th className="px-6 py-4 text-left font-bold whitespace-nowrap">カード名</th>
                  <th className="px-6 py-4 text-center font-bold whitespace-nowrap">発行時間</th>
                  <th className="px-6 py-4 text-center font-bold whitespace-nowrap">受取方法</th>
                  <th className="px-6 py-4 text-center font-bold whitespace-nowrap">店舗受取</th>
                  <th className="px-6 py-4 text-center font-bold whitespace-nowrap">年会費</th>
                  <th className="px-6 py-4 text-center font-bold whitespace-nowrap">還元率</th>
                  <th className="px-6 py-4 text-center font-bold whitespace-nowrap">詳細</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((card, index) => (
                  <tr
                    key={card.id}
                    className={`${
                      index === 0
                        ? 'bg-amber-50 border-l-4 border-amber-400'
                        : index % 2 === 0
                        ? 'bg-gray-50'
                        : 'bg-white'
                    } hover:bg-teal-50 transition-colors duration-200`}
                  >
                    <td className="px-6 py-4 font-bold text-gray-900 whitespace-nowrap">
                      {index === 0 && (
                        <span className="inline-block bg-amber-400 text-white text-xs px-2 py-1 rounded mr-2">
                          1位
                        </span>
                      )}
                      {card.name}
                    </td>
                    <td className="px-6 py-4 text-center font-bold text-teal-600 whitespace-nowrap">
                      {card.issueTime}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-700 whitespace-nowrap">
                      {card.receiveMethod}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-700">
                      {card.storePickup === '○' ? (
                        <span className="text-teal-600 font-bold">○</span>
                      ) : (
                        <span className="text-gray-400">×</span>
                      )}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-700 whitespace-nowrap">
                      {card.annualFee}
                    </td>
                    <td className="px-6 py-4 text-center font-semibold text-gray-900 whitespace-nowrap">
                      {card.returnRate}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <Link
                        to={card.detailUrl}
                        className="inline-block bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-teal-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
                      >
                        詳細
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 text-sm text-gray-600 text-center">
          ※最新情報は各公式サイトをご確認ください
        </div>
      </div>
    </section>
  );
}
